import React, { createContext, useState, Dispatch } from 'react';

interface ProviderProps {
  children: JSX.Element;
}

interface ContextValues {
  collapsed: boolean;
  setCollapsed: Dispatch<React.SetStateAction<boolean>>;
}

const defaultValue = {
  collapsed: false,
  setCollapsed: function (value: React.SetStateAction<boolean>): void {
    value;
    throw new Error('Function not implemented.');
  },
};

export const LayoutContext = createContext<ContextValues>(defaultValue);

export const LayoutProvider = ({ children }: ProviderProps) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <LayoutContext.Provider value={{ collapsed, setCollapsed }}>
      {children}
    </LayoutContext.Provider>
  );
};
